import { useTaxonomyStore } from '@modules/taxonomy/store/taxonomyStore';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { alpha, Button, Stack } from '@mui/material';
import { useMuiModalContext } from '../Modal/ModalContext';
import { TypographyWithEllipsis } from '../TypographyWithEllipsis';
import { EditPromptConfirmationDialogContent } from './EditPromptConfirmationDialogContent';
import { EditReasonDescriptionPromptInput } from './EditReasonDescriptionPromptInput';

export const EditReasonDescriptionPrompt = () => {
  const { openModal } = useMuiModalContext();

  const { description, isEditPromptMode } = useTaxonomyStore(
    ({ createReasonV3State: { visual, description } }) => ({
      description,
      isEditPromptMode: visual?.isEditPromptMode,
    }),
  );

  const openEditPromptConfirmationDialog = () => {
    openModal({
      contentComponent: () => <EditPromptConfirmationDialogContent />,
      modalProps: {
        fullWidth: true,
        maxWidth: 'xs',
        PaperProps: {
          elevation: 3,
        },
      },
    });
  };

  if (isEditPromptMode) {
    return <EditReasonDescriptionPromptInput />;
  }

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      px={3}
      py={1.25}
      sx={{ background: (theme) => alpha(theme.palette.text.primary, 0.04) }}
    >
      <TypographyWithEllipsis
        variant="body2"
        shouldShowTooltip={false}
        color="primary"
      >
        Prompt: {description}
      </TypographyWithEllipsis>
      <Button
        size="small"
        variant="text"
        startIcon={<EditRoundedIcon />}
        sx={{ minWidth: 140 }}
        onClick={openEditPromptConfirmationDialog}
      >
        Edit Prompt
      </Button>
    </Stack>
  );
};
